import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import YoutubePopup from '@Theme/natucare/components/YoutubePopup/YoutubePopup';
import Picture from '@Theme/natucare/components/Picture/Picture';
import Icon from '@Theme/natucare/components/Icon/Icon';
import * as styles from './SlideItem.module.scss';
/**
 * SlideItem component
 */
const SlideItem = _ref => {
  let {
    poster,
    videoId,
    youtubePopupContainerRef
  } = _ref;
  const {
    0: isOpen,
    1: setIsOpen
  } = useState(false);
  const handlePopup = () => {
    setIsOpen(prevState => !prevState);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles.root,
    onClick: handlePopup
  }, /*#__PURE__*/React.createElement(Picture, {
    xs: {
      src: poster.src
    },
    alt: poster.alt,
    pictureClassname: styles.rootPicture,
    imgClassname: styles.rootImage
  }), /*#__PURE__*/React.createElement(Icon, {
    name: "testimonialsVideoPlay",
    classname: styles.rootIcon
  })), youtubePopupContainerRef.current && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/createPortal(/*#__PURE__*/React.createElement(YoutubePopup, {
    id: videoId,
    isOpen: isOpen,
    handler: handlePopup
  }), youtubePopupContainerRef.current)));
};
export default SlideItem;